import React from "react";
import ScheduleFlag from "./ScheduleFlag";

const FinishedFlag = () => <ScheduleFlag text="Finished" color="#6EACDE" />;

export default FinishedFlag;
